import { cloneElement } from "react";
import {
  BiAccessibility,
  BiBeer,
  BiBus,
  BiCableCar,
  BiCake,
  BiCamera,
  BiCoffee,
  BiCycling,
  BiDoorOpen,
  BiDrink,
  BiError,
  BiGift,
  BiHeartSquare,
  BiLandscape,
  BiMusic,
  BiRestaurant,
  BiRun,
  BiSolidShip,
  BiStore,
  BiTrain,
} from "react-icons/bi";
import { BsTicketPerforated } from "react-icons/bs";
import { FaToriiGate } from "react-icons/fa";
import { GiDango, GiKimono } from "react-icons/gi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IconBaseProps } from "react-icons/lib";
import { MdOutlineStadium, MdOutlineTempleBuddhist } from "react-icons/md";
import { PiBackpack, PiBowlFood } from "react-icons/pi";
import { TbBottle } from "react-icons/tb";
import { MtGuideIcon } from "./MtGuideIcon";

const icons = new Map([
  ["BiAccessibility", <BiAccessibility />],
  ["BiBeer", <BiBeer />],
  ["BiBus", <BiBus />],
  ["BiCableCar", <BiCableCar />],
  ["BiCake", <BiCake />],
  ["BiCamera", <BiCamera />],
  ["BiCoffee", <BiCoffee />],
  ["BiCycling", <BiCycling />],
  ["BiDoorOpen", <BiDoorOpen />],
  ["BiDrink", <BiDrink />],
  ["BiGift", <BiGift />],
  ["BiHeartSquare", <BiHeartSquare />],
  ["BiLandscape", <BiLandscape />],
  ["BiMusic", <BiMusic />],
  ["BiRestaurant", <BiRestaurant />],
  ["BiRun", <BiRun />],
  ["BiSolidShip", <BiSolidShip />],
  ["BiStore", <BiStore />],
  ["BiTrain", <BiTrain />],
  ["BsTicketPerforated", <BsTicketPerforated />],
  ["FaToriiGate", <FaToriiGate />],
  ["GiDango", <GiDango />],
  ["MdOutlineStadium", <MdOutlineStadium />],
  ["MdOutlineTempleBuddhist", <MdOutlineTempleBuddhist />],
  ["MtGuide", <MtGuideIcon />],
  ["PiBackpack", <PiBackpack />],
  ["PiBowlFood", <PiBowlFood />],
  ["TbBottle", <TbBottle />],
  ["GiKimono", <GiKimono />],
  ["IoDocumentTextOutline", <IoDocumentTextOutline />],
]);

export const iconNames = Array.from(icons.keys());

export function getIcon(iconName: string, props?: IconBaseProps) {
  const icon = icons.get(iconName) ?? <BiError />;
  return cloneElement(icon, { ...props });
}
